// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proj-imgbx {
  position: relative;
  border-radius: 30px;
  overflow: hidden;
  margin-bottom: 24px;
}
.proj-imgbx::before {
  content: "";
  background: linear-gradient(90.21deg, var(--cyan) -5.91%, var(--dark-green) 111.58%);
  opacity: 0.85;
  position: absolute;
  width: 100%;
  height: 0;
  transition: 0.4s ease-in-out;
}
.proj-imgbx:hover::before {
  height: 100%;
}
.proj-txtx {
  position: absolute;
  text-align: center;
  top: 65%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 0.5s ease-in-out;
  opacity: 0;
  width: 100%;
}
.proj-imgbx:hover .proj-txtx {
  top: 50%;
  opacity: 1;
}
.proj-txtx h4 {
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 0.8px;
  line-height: 1.1em;
}
.proj-txtx span {
  font-style: italic;
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.8px;
}
`, "",{"version":3,"sources":["webpack://./packages/studytour-io-app/src/components/Projects/ProjectCard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,oFAAoF;EACpF,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,4BAA4B;AAC9B;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,4BAA4B;EAC5B,UAAU;EACV,WAAW;AACb;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB","sourcesContent":[".proj-imgbx {\n  position: relative;\n  border-radius: 30px;\n  overflow: hidden;\n  margin-bottom: 24px;\n}\n.proj-imgbx::before {\n  content: \"\";\n  background: linear-gradient(90.21deg, var(--cyan) -5.91%, var(--dark-green) 111.58%);\n  opacity: 0.85;\n  position: absolute;\n  width: 100%;\n  height: 0;\n  transition: 0.4s ease-in-out;\n}\n.proj-imgbx:hover::before {\n  height: 100%;\n}\n.proj-txtx {\n  position: absolute;\n  text-align: center;\n  top: 65%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  transition: 0.5s ease-in-out;\n  opacity: 0;\n  width: 100%;\n}\n.proj-imgbx:hover .proj-txtx {\n  top: 50%;\n  opacity: 1;\n}\n.proj-txtx h4 {\n  font-size: 30px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  line-height: 1.1em;\n}\n.proj-txtx span {\n  font-style: italic;\n  font-weight: 400;\n  font-size: 15px;\n  letter-spacing: 0.8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
